import { Skeleton } from "@/core/components/ui/skeleton";
import { Stack } from "@/core/components/ui/stack";
import { Tabs } from "@/core/components/ui/tabs";
import { BusinessSettingsSidebarWrapper } from "@/business-settings/common/business-settings-sidebar-wrapper";

export const ReferralSourceSidebarSkeleton = () => (
  <BusinessSettingsSidebarWrapper>
    <Stack
      direction="row"
      justify="between"
      align="center"
      className={"flex-none bg-bg-secondary/50 p-6"}
    >
      <Stack gap={"md"}>
        <Skeleton className="h-2 w-10"></Skeleton>
        <Skeleton className="h-3 w-20"></Skeleton>
      </Stack>
      <Stack direction="row" align="center" gap="sm"></Stack>
    </Stack>
    <div className="flex-1 overflow-hidden">
      <Stack gap="none" fullWidth className="h-full">
        <Tabs className="flex w-full flex-1 flex-col gap-6 overflow-hidden p-6">
          <Skeleton className="h-[58px] w-full"></Skeleton>

          <Stack fullWidth gap="sm">
            <Skeleton className="h-[16px] w-40"></Skeleton>
            <Skeleton className="h-[128px] w-full"></Skeleton>
          </Stack>

          <Skeleton className="h-[58px] w-full"></Skeleton>

          <Skeleton className="h-[58px] w-full"></Skeleton>

          <Stack direction="row" gap="md">
            <Skeleton className="h-[40px] w-[156px]"></Skeleton>
            <Skeleton className="h-[40px] w-[104px]"></Skeleton>
          </Stack>

          <Skeleton className="h-[1px] w-full"></Skeleton>

          <Skeleton className="h-[44px] w-full"></Skeleton>
        </Tabs>
      </Stack>
    </div>
  </BusinessSettingsSidebarWrapper>
);
